import { cn } from "helpers/classNames";

type PrimaryProps = {
  isLoading?: boolean;
  loadingText?: string;
  children: string;
  type?: "submit" | "button";
  onClick?: () => void;
  variant?: "primary" | "danger";
  disabled?: boolean;
};

export const SheetPrimaryButton = ({
  isLoading = false,
  loadingText = "Sparar...",
  children,
  type = "submit",
  onClick,
  variant = "primary",
  disabled = false,
}: PrimaryProps) => (
  <button
    type={type}
    onClick={onClick}
    disabled={isLoading || disabled}
    className={cn(
      "flex h-12 flex-1 items-center justify-center rounded-xl text-base font-semibold text-white shadow-sm transition-colors disabled:bg-gray-400",
      variant === "primary" && "bg-blue-600 active:bg-blue-700",
      variant === "danger" && "bg-red-600 active:bg-red-700",
    )}
  >
    {isLoading && (
      <svg
        className="-ml-1 mr-3 h-5 w-5 animate-spin text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    )}
    {isLoading ? loadingText : children}
  </button>
);

type SecondaryProps = {
  onClick: () => void;
  children?: string;
};

export const SheetSecondaryButton = ({
  onClick,
  children = "Avbryt",
}: SecondaryProps) => (
  <button
    type="button"
    onClick={onClick}
    className="flex h-12 flex-1 items-center justify-center rounded-xl bg-white text-base font-semibold text-gray-700 ring-1 ring-inset ring-gray-200 transition-colors active:bg-gray-25"
  >
    {children}
  </button>
);
